import React from 'react';
import Icon from 'components/AppIcon';
import StatusIndicatorBadge from 'components/ui/StatusIndicatorBadge';

const ReviewStatsWidget = () => {
  const mockStats = {
    pending: 23,
    approved: 156,
    rejected: 12,
    expiringSoon: 8,
    todayReviews: 7,
    avgReviewTime: '2.3 hours'
  };

  const mockUpcomingDeadlines = [
    {
      id: 'BD004',
      workerName: 'Chen Wei',
      expiryDate: '2024-04-12',
      daysLeft: 5,
      priority: 'high'
    },
    {
      id: 'BD007',
      workerName: 'Priya Sharma',
      expiryDate: '2024-04-15',
      daysLeft: 8,
      priority: 'medium'
    },
    {
      id: 'BD009',
      workerName: 'Ali Hassan',
      expiryDate: '2024-04-18',
      daysLeft: 11,
      priority: 'low'
    }
  ];

  const mockRecentActivity = [
    {
      id: 1,
      action: 'Approved',
      workerName: 'Maria Santos',
      time: '2 hours ago',
      type: 'approval'
    },
    {
      id: 2,
      action: 'Rejected',
      workerName: 'John Smith',
      time: '4 hours ago',
      type: 'rejection'
    },
    {
      id: 3,
      action: 'Reviewed',
      workerName: 'Ahmed Khan',
      time: '6 hours ago',
      type: 'review'
    }
  ];

  return (
    <div className="space-y-6">
      {/* Review Statistics */}
      <div className="card">
        <div className="p-6">
          <h3 className="text-lg font-semibold text-text-primary mb-4">Review Statistics</h3>
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <Icon name="Clock" size={16} className="text-warning" />
                <span className="text-sm text-text-secondary">Pending Reviews</span>
              </div>
              <span className="text-lg font-semibold text-warning">{mockStats.pending}</span>
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <Icon name="CheckCircle" size={16} className="text-success" />
                <span className="text-sm text-text-secondary">Approved</span>
              </div>
              <span className="text-lg font-semibold text-success">{mockStats.approved}</span>
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <Icon name="XCircle" size={16} className="text-error" />
                <span className="text-sm text-text-secondary">Rejected</span>
              </div>
              <span className="text-lg font-semibold text-error">{mockStats.rejected}</span>
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <Icon name="AlertTriangle" size={16} className="text-accent" />
                <span className="text-sm text-text-secondary">Expiring Soon</span>
              </div>
              <span className="text-lg font-semibold text-accent">{mockStats.expiringSoon}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Today's Performance */}
      <div className="card">
        <div className="p-6">
          <h3 className="text-lg font-semibold text-text-primary mb-4">Today's Performance</h3>
          <div className="space-y-4">
            <div className="text-center">
              <div className="text-2xl font-bold text-primary">{mockStats.todayReviews}</div>
              <div className="text-sm text-text-secondary">Reviews Completed</div>
            </div>
            <div className="text-center">
              <div className="text-lg font-semibold text-text-primary">{mockStats.avgReviewTime}</div>
              <div className="text-sm text-text-secondary">Avg Review Time</div>
            </div>
          </div>
        </div>
      </div>

      {/* Upcoming Deadlines */}
      <div className="card">
        <div className="p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold text-text-primary">Expiring Soon</h3>
            <Icon name="AlertTriangle" size={16} className="text-warning" />
          </div>
          <div className="space-y-3">
            {mockUpcomingDeadlines.map((item) => (
              <div key={item.id} className="flex items-center justify-between p-3 bg-warning-50 rounded-lg border border-warning-200">
                <div>
                  <p className="text-sm font-medium text-text-primary">{item.workerName}</p>
                  <p className="text-xs text-text-secondary">ID: {item.id}</p>
                </div>
                <div className="text-right">
                  <p className="text-sm font-semibold text-warning">{item.daysLeft} days</p>
                  <StatusIndicatorBadge status={item.priority} size="sm" />
                </div>
              </div>
            ))}
          </div>
          <button className="w-full mt-4 text-sm text-primary hover:text-primary-700 font-medium">
            View All Expiring
          </button>
        </div>
      </div>

      {/* Recent Activity */}
      <div className="card">
        <div className="p-6">
          <h3 className="text-lg font-semibold text-text-primary mb-4">Recent Activity</h3>
          <div className="space-y-3">
            {mockRecentActivity.map((activity) => (
              <div key={activity.id} className="flex items-center space-x-3">
                <div className={`w-2 h-2 rounded-full ${
                  activity.type === 'approval' ? 'bg-success' :
                  activity.type === 'rejection' ? 'bg-error' : 'bg-accent'
                }`} />
                <div className="flex-1">
                  <p className="text-sm text-text-primary">
                    <span className="font-medium">{activity.action}</span> {activity.workerName}
                  </p>
                  <p className="text-xs text-text-secondary">{activity.time}</p>
                </div>
              </div>
            ))}
          </div>
          <button className="w-full mt-4 text-sm text-primary hover:text-primary-700 font-medium">
            View All Activity
          </button>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="card">
        <div className="p-6">
          <h3 className="text-lg font-semibold text-text-primary mb-4">Quick Actions</h3>
          <div className="space-y-2">
            <button className="w-full flex items-center space-x-2 p-3 text-left text-sm text-text-primary hover:bg-secondary-50 rounded-md transition-colors duration-150">
              <Icon name="FileText" size={16} />
              <span>Generate Report</span>
            </button>
            <button className="w-full flex items-center space-x-2 p-3 text-left text-sm text-text-primary hover:bg-secondary-50 rounded-md transition-colors duration-150">
              <Icon name="Download" size={16} />
              <span>Export Data</span>
            </button>
            <button className="w-full flex items-center space-x-2 p-3 text-left text-sm text-text-primary hover:bg-secondary-50 rounded-md transition-colors duration-150">
              <Icon name="Settings" size={16} />
              <span>Review Settings</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewStatsWidget;